// Featured Collection Section

class CustomFeaturedCollection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
    };

    var slideCountdesk = this.getAttribute("data-slide-count");
    var slideSpace = this.getAttribute("data-slide-space");
    var slideCountmob = this.getAttribute("data-slide-count-mob");

    var swiper = new Swiper(".cfc-slide-main-box", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        280: {
          slidesPerView: slideCountmob,
          spaceBetween: 15,
        },
        750: {
          slidesPerView: slideCountmob,
          spaceBetween: 25,
        },
        990: {
          slidesPerView: slideCountdesk,
          spaceBetween: slideSpace,
        },
      },
    });

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-featured-collection", CustomFeaturedCollection);

// Dog people Section

class DogPeopleSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("dog-people-section", DogPeopleSection);

//Testimonial Section

class CustomTestimonials extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
    };

    $(this).css({"opacity":"1"});

    var testiCount = this.getAttribute("data-count");
    var testiSpace = this.getAttribute("data-count-space");
    var testiCountmob = this.getAttribute("data-count-mob");

    var swiper = new Swiper(".custom-testimonail-box", {
      loop: true,
      navigation: {
        nextEl: ".testimony-button-next",
        prevEl: ".testimony-button-prev",
      },
      pagination: {
        el: ".tm-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="tm-dot swiper-pagination-bullet"></span>`;
        },
      },
      breakpoints: {
        280: {
          slidesPerView: testiCountmob,
          spaceBetween: 20,
        },
        601: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        990: {
          slidesPerView: testiCount,
          spaceBetween: testiSpace,
        },
      },
    });

    if ($(".testimony-button-next").hasClass("swiper-button-lock")) {
      $(".tm-pagination").addClass("swiper-button-lock");
    } else {
      $(".tm-pagination").removeClass("swiper-button-lock");
    }

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-testimonial", CustomTestimonials);

// CUSTOM CARD SLIDER
class CardSliderSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
    };

      var sectionId = this.getAttribute("data-sectionid");

     var swiper =  new Swiper(".card-slider-inner-box-"+ sectionId , {
      slidesPerView: 4.5,
      spaceBetween: 20,
      freeMode: true,
      navigation: {
        nextEl: ".next-"+sectionId,
        prevEl: ".prev-"+sectionId,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      breakpoints: {
        280: {
          slidesPerView: "auto",
          spaceBetween: 10,
        },
        769: {
          slidesPerView: 3.5,
          spaceBetween: 10,
        },
        991: {
          slidesPerView: 4.4,
          spaceBetween: 20,
        },
      },
    });

  
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("card-slider-section", CardSliderSection);
